<div class="dropdown-container">
  <div class="w-100">
    <!-- Dropdown unificado -->
    <p-dropdown 
      [options]="unifiedSearchOptions" 
      [(ngModel)]="selectedUnifiedOption"
      (onChange)="changeSelectedUnified($event)"
      placeholder="Selecione Cliente / Embarcação"
      [filter]="true"
      filterBy="label"
      [showClear]="true"
      [disabled]="disabled"
      optionLabel="label"
      optionValue="value"
      optionDisabled="disabled"
      class="w-100">
      <ng-template let-option pTemplate="selectedItem">
        <span [ngStyle]="{'color': option?.disabled ? 'red' : '#222222' }">
          {{option?.data?.customer?.id}} <fa-icon [icon]="'user'" style="margin-right: 5px;"></fa-icon> {{option?.data?.customer?.name}} - {{ option?.data?.roleLabel || option?.data?.customer?.accessGroup?.name }} / <fa-icon [icon]="'ship'" style="margin-right: 5px;"></fa-icon> {{option?.data?.boat?.name}}
        </span>
      </ng-template>
      <ng-template let-option pTemplate="item">
        <div>
          {{option?.data?.customer?.id}} <fa-icon [icon]="'user'" style="margin-right: 5px;"></fa-icon> {{option?.data?.customer?.name}} - {{ option?.data?.roleLabel || option?.data?.customer?.accessGroup?.name }} / <fa-icon [icon]="'ship'" style="margin-right: 5px;"></fa-icon> {{option?.data?.boat?.name}}
        </div>
      </ng-template>
    </p-dropdown>
  </div>
</div>